export default {
	40: { m: 5.99, h: 0.84 },
	41: { m: 6.01, h: 0.82},
	42: { m: 6.00, h: 0.80},
	43: { m: 6.02, h: 0.78},
	44: { m: 5.99, h: 0.76},
	45: { m: 6.03, h: 0.74},
	46: { m: 6.35, h: 0.78},
	47: { m: 6.64, h: 0.82},
	48: { m: 6.89, h: 0.86},
	49: { m: 7.13, h: 0.89},
	50: { m: 7.33, h: 0.91},
	51: { m: 7.78, h: 1.04},
	52: { m: 8.18, h: 1.15},
	53: { m: 8.62, h: 1.25},
	54: { m: 9.07, h: 1.35},
	55: { m: 9.49, h: 1.45},
	56: { m: 10.02, h: 1.64},
	57: { m: 10.57, h: 1.82},
	58: { m: 11.08, h: 1.99},
	59: { m: 11.62, h:	2.15},
	60: { m: 12.15, h: 2.30},
	
	61: { m: 13.06, h: 2.58},
	
	62: { m: 14.00, h:	2.85},
	
	63: { m: 14.85, h: 3.09},
	
	64: { m: 15.68, h: 3.31},
	
	65: { m: 16.50, h: 3.52},
	
	66: { m: 17.32, h: 3.95},
	
	67: { m: 18.16, h: 4.37},
	
	68: { m: 18.97, h: 4.75},
	
	69: { m: 19.72, h: 5.10},
	
	70: { m: 20.34, h: 5.40},
	
	71: { m: 20.34, h: 5.40},
	
	72: { m: 20.34, h: 5.40},
	
	73: { m: 20.34, h: 5.40},
	
	74: { m: 20.34, h: 5.40},
	
	75: { m: 20.34, h: 5.40},
	
	76: { m: 20.34, h: 5.40},
	
	77: { m: 20.34, h: 5.40},
	
	78: { m: 20.34, h: 5.40},
	
	79: { m: 20.34, h: 5.40},
	
	80: { m: 20.34, h:	5.40},
	
	81: { m: 20.34, h: 5.40},
	
	82: { m: 20.34, h: 5.40},
	
	83: { m: 20.34, h: 5.40},
	
	84: { m: 20.34, h: 5.40},
	
	85: { m: 20.34, h: 5.40},
	
	86: { m: 20.34, h: 5.40},
	
	87: { m: 20.34, h: 5.40},
	
	88: { m: 20.34, h: 5.40},
	
	89: { m: 20.34, h: 5.40},
	
	90: { m: 20.34, h: 5.40}
}